import { render, staticRenderFns } from "./TrustPilot.vue?vue&type=template&id=e8a243e8&scoped=true"
import script from "./TrustPilot.vue?vue&type=script&lang=ts"
export * from "./TrustPilot.vue?vue&type=script&lang=ts"
import style0 from "./TrustPilot.vue?vue&type=style&index=0&id=e8a243e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a243e8",
  null
  
)

export default component.exports